export default class LanguageDropdown {
    constructor(element, options = {}) {
        this.element = element || null;
        if (!element) return;

        this.onLanguageSelect = typeof options.onLanguageSelect === 'function' ? options.onLanguageSelect : null;
        this.titleButton = this.element.querySelector('.language-dropdown__title');

        window.addEventListener('click', e => {
            const target = e.target;
            if (!(target instanceof Element)) return;

            const inside = target.closest('.language-dropdown');
            if (inside !== this.element) {
                this.close();
                return;
            }

            const optionBtn = target.closest('.language-dropdown__option');
            if (optionBtn && this.element.contains(optionBtn)) {
                this.close();
                const lang = optionBtn.dataset.lang;
                if (lang && this.onLanguageSelect) this.onLanguageSelect(lang);
                return;
            }

            const titleBtn = target.closest('.language-dropdown__title');
            if (titleBtn && titleBtn === this.titleButton) {
                this.element.classList.contains('is-open') ? this.close() : this.open();
            }
        });
    }

    open() {
        if (!this.element || this.element.classList.contains('is-open')) return;
        this.element.classList.add('is-open');
        if (this.titleButton) this.titleButton.setAttribute('aria-expanded', 'true');
    }

    close() {
        if (!this.element || !this.element.classList.contains('is-open')) return;
        this.element.classList.remove('is-open');
        if (this.titleButton) this.titleButton.setAttribute('aria-expanded', 'false');
    }
}
